import { languageMessages } from 'src/utils/messages';

export const languageOptions = [
    { value: 'en-US', label: languageMessages.english },
    { value: 'bg-BG', label: languageMessages.bulgarian },
];
